interface PasswordInputViewProps {
  id?: string;
  name?: string;
  value: string;
  placeholder?: string;
  label?: string;
  error?: string;
  disabled?: boolean;
  required?: boolean;
  autoComplete?: string;
  showPassword: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  onToggleVisibility: () => void;
  className?: string;
  wrapperClassName?: string;
}

export const PasswordInputView = ({
  id,
  name,
  value,
  placeholder,
  label,
  error,
  disabled = false,
  required = false,
  autoComplete,
  showPassword,
  onChange,
  onBlur,
  onToggleVisibility,
  className = "",
  wrapperClassName = "mb-5",
}: PasswordInputViewProps) => {
  const inputClasses = `block w-full px-4 py-3 text-foreground border rounded-lg bg-surface-subtle focus-visible:shadow-focus transition-none outline-none ${
    error ? "border-destructive bg-destructive-subtle" : "border-input"
  } ${disabled ? "bg-surface-sunken cursor-not-allowed opacity-60" : ""} ${className}`;

  return (
    <div className={wrapperClassName}>
      {label && (
        <label
          htmlFor={id || name}
          className="mb-2 block text-sm font-semibold text-muted-foreground"
        >
          {label}
          {required && <span className="ml-1 text-destructive">*</span>}
        </label>
      )}
      <div className="relative">
        <input
          id={id || name}
          name={name}
          type={showPassword ? "text" : "password"}
          value={value}
          placeholder={placeholder}
          onChange={onChange}
          onBlur={onBlur}
          disabled={disabled}
          required={required}
          autoComplete={autoComplete}
          className={inputClasses}
        />
        <button
          type="button"
          onClick={onToggleVisibility}
          className="absolute right-3 top-1/2 -translate-y-1/2 transform rounded-sm text-muted-foreground hover:text-foreground focus:outline-none focus-visible:shadow-focus"
          tabIndex={-1}
        >
          {showPassword ? (
            <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.29 3.29m13.42 13.42L21 21M12 12l.01.01M3 3l18 18"
              />
            </svg>
          ) : (
            <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
              />
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
              />
            </svg>
          )}
        </button>
      </div>
      <p
        className={`mt-1.5 min-h-[1rem] text-xs font-medium ${error ? "text-destructive-text" : "text-transparent"}`}
        aria-live="polite"
      >
        {error || "_"}
      </p>
    </div>
  );
};
